import { Stack } from "@chakra-ui/react";
import React from "react";
import FormikControl from "../../Formik/index";

export const ShirtSizeForm = ({
  height,
  chest,
  stomach,
  front,
  pot,
  shoulder,
  bhai,
  cup,
  throat,
  bag,
  bhailoosing,
  seat,
}) => {
  return (
    <Stack spacing="5">
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        type="number"
        label="उंची"
        name={height}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        type="number"
        label="छाती"
        name={chest}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="पोट"
        type="number"
        name={stomach}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="सीट"
        type="number"
        name={seat}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="फ्रंट"
        type="number"
        name={front}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="पोट"
        type="number"
        name={pot}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="शोल्डर"
        type="number"
        name={shoulder}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="भाई"
        type="number"
        name={bhai}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="कप"
        type="number"
        name={cup}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="गळा"
        type="number"
        name={throat}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="बॅग"
        type="number"
        name={bag}
      />
      <FormikControl
        fontSize="20px"
        control="chakrainput"
        label="भाई लूझिंग"
        type="number"
        name={bhailoosing}
      />
    </Stack>
  );
};
